<template>
  <CustomPage title="重设密码">
    <div slot="content" class="content">
      <div class="tip">
        请设置支付密码，需要6位数字
      </div>
      <PasswordInput :value="password" :length="6" :focused="showKeyboard" :mask="false" @focus="showKeyboard = true" />
      <NumberKeyboard
        v-model="password"
        :show="showKeyboard"
        @blur="showKeyboard = false"
      />
      <div class="btn-box">
        <Button class="btn" @click="nextHandle" :loading="loading"
          >下一步</Button
        >
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import { mapState } from 'vuex'
import CustomPage from '@/components/custom-page.vue'
import CustomView from '@/components/custom-view.vue'
import { validPassword } from '@/utils/vaildate'
import { PasswordInput, NumberKeyboard, Button, Toast } from 'vant'
export default {
  components: { CustomPage, CustomView, PasswordInput, NumberKeyboard, Button },
  data() {
    return {
      validPassword,
      loading: false,
      password: '',
      showKeyboard: false
    }
  },
  watch: {
    password(val) {
      setTimeout(() => {
        const dom = document.querySelectorAll('.van-password-input__item')
        for (let i = 0; i < 6; i++) {
          if (i <= val.length - 1) {
            dom[i].classList.add('active')
          } else {
            dom[i].classList.remove('active')
          }
        }
      }, 50)
      if (val.length === 6) {
        this.showKeyboard = false
      }
    },
  },
  computed: {
    ...mapState({
      userInfoMobile: (state) => state.user.userInfoMobile,
      code_phone: (state) => state.sms.code_phone,
      code_flag: (state) => state.sms.code_flag,
    }),
  },
  methods: {
    nextHandle() {
      if (this.password.length < 6) {
        return Toast.fail('请输入支付密码')
      }
      if (this.code_phone === this.userInfoMobile && this.code_flag) {
        this.routerHandle()
      } else {
        this.loading = true
        this.$store
          .dispatch('sms/payReviseSendCode', this.userInfoMobile)
          .then((res) => {
            Toast.success('已发送验证码')
            this.loading = false
            this.routerHandle()
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    routerHandle() {
      const name = this.$route.name === 'SettleSafePayPwd' ? 'SettleSafePayPwdCode' : 'SettingSafePayPwdCode'
      this.$router.push({
        name,
        query: {
          type: 'pay_password',
          phone: this.userInfoMobile,
          newPassword: this.password,
        },
      })
    }
  },
}
</script>

<style lang="less" scoped>
.content {
  padding: 0 20px;
}
.tip {
  padding: 42px 20px 40px;
  font-size: 32px;
  line-height: 40px;
  color: #808080;
}
.btn-box {
  padding: 80px 20px 0;
}
.van-password-input {
  margin: 0;
  .van-password-input__security::after {
    border: none;
  }
}
.btn {
  width: 100%;
  background: #e82035;
  line-height: 82px;
  border-radius: 41px;
  font-size: 26px;
  text-align: center;
  color: #fff;
}
</style>
<style lang="less">
.van-password-input__item {
  margin: 0 14px;
  &::before {
    position: absolute;
    bottom: 0;
    content: '';
    left: 0;
    height: 1px;
    background: #333333;
    z-index: 9;
    width: 0;
    transition: 0.3s;
  }
  &.active::before {
    width: 100%;
  }
  &::after {
    position: absolute;
    content: '';
    border-bottom: 1px solid #aeaeae;
    border-left-width: 0;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transform: none;
  }
}
</style>